<template>
	<view class="news-container">
		<uni-search-bar
			class="seacrh-style"
			radius="36"
			bgColor="#f5f5f5"
			placeholder="搜索标题"
			clearButton="auto"
			cancelButton="none"
			@confirm="search"
		/>
		<view v-for="(item, index) in data" :key="index" class="notify-item" @click="showDetail(index)">
			<uni-badge
				:is-dot="true"
				:text="1"
				absolute="rightTop"
				size="normal"
			>
				<image src="@/static/merchant/ic_xiaoxi@2x.png" mode=""></image>
			</uni-badge>
			
			<view class="notify-message">
				<view class="notify-title">系统通知</view>
				<view class="notify-content">尊敬的各位用户:为了给您带来更好的体验,电子商务平台于2022年12月30日已完成优化更新。</view>
				<view class="notify-time">发布于2023-03-12 19:00</view>
			</view>
		</view>
		<view class="bottom-style">{{ isMore ? '-没有更多了-' : '上拉加载更多' }}</view>
		<view class="safe-area"></view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				data: [1,2,3,4,5,6,7,7],
				isMore: true
			};
		},
		methods: {
			search(res) {
				
			},
			showDetail(index) {
				uni.navigateTo({
					url: '/pages/merchant/merchatCenter/notifyDetail'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
.news-container {
	height: 100%;
	overflow-y: scroll;
	background-color: #fff;
}
.seacrh-style {
	height: 72rpx;
	background: #F5F5F5;
	border-radius: 36rpx;
}
.notify-item {
	padding: 28rpx 32rpx;
	height: 234rpx;
	box-sizing: border-box;
	border-bottom: 2rpx solid #E5E5E5;
	display: flex;
	image {
		width: 72rpx;
		height: 72rpx;
		background: #FCECEC;
		border-radius: 36rpx;
		
	}
	.notify-message {
		margin-left: 16rpx;
		flex: 1;
		.notify-title {
			height: 32rpx;
			font-size: 32rpx;
			font-weight: 500;
			color: #222222;
			line-height: 32rpx;
			margin-bottom: 20rpx;
		}
		.notify-content {
			font-size: 26rpx;
			font-weight: 400;
			color: #666666;
			line-height: 40rpx;
			margin-bottom: 24rpx;
		}
		.notify-time {
			height: 24rpx;
			font-size: 24rpx;
			font-weight: 400;
			color: #999999;
			line-height: 24rpx;
		}
	}
}
.bottom-style {
	height: 22rpx;
	font-size: 22rpx;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 22rpx;
	text-align: center;
	margin-top: 50rpx;
}
.safe-area {
	height: env(safe-area-inset-bottom);
	padding: 20rpx;
}
</style>
